import apiClient from "../apiClient";

export const getAllMembershipsAPI = async () => {
  try {
    const response = await apiClient.get("subscriptions/memberships-plans");

    return response?.data?.plans;
  } catch (error) {
    throw error;
  }
};

export const createMembership = async ({ membershipData }) => {
  try {
    // console.log("Datos enviados", membershipData);

    const response = await apiClient.post(
      "subscriptions/memberships-plans-create",
      membershipData
    );
    // console.log("Respuest de creacion de membresía", response?.data);

    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const updateMembership = async ({ membershipData, planId }) => {
  try {
    
    const response = await apiClient.put(
      `subscriptions/memberships-plans/${planId}`,
      membershipData
    );
    return response?.data;
  } catch (error) {
    throw error;
  }
};

export const deleteMembership = async ({ planId }) => {
  try {
    const response = await apiClient.delete(
      `subscriptions/memberships-plans/${planId}`
    );
    // console.log("Peticion a eliminar membresia", response);
    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};

export const activateMembership = async ({ planId }) => {
  try {
    const response = await apiClient.put(
      `subscriptions/memberships-plans-active/${planId}`
    );
    // console.log("Peticion a activar membresia", response);
    return response?.data ?? {};
  } catch (error) {
    throw error;
  }
};
